/* ============================================
   LA DIAMOND — Wishlist (localStorage)
   ============================================ */

const WISHLIST_KEY = 'la_diamond_wishlist';

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
  catch { return []; }
}

function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function isWishlisted(id) {
  return getWishlist().some(item => item.id === String(id));
}

function addToWishlist(id, title, price, image, url) {
  const items = getWishlist();
  if (!items.some(i => i.id === String(id))) {
    items.push({ id: String(id), title, price, image, url });
    saveWishlist(items);
  }
}

function removeFromWishlist(id) {
  saveWishlist(getWishlist().filter(i => i.id !== String(id)));
}

function toggleWishlist(id, title, price, image, url) {
  if (isWishlisted(id)) {
    removeFromWishlist(id);
    return false;
  } else {
    addToWishlist(id, title, price, image, url);
    return true;
  }
}

function updateWishlistBtnState(btn, wishlisted) {
  const svg = btn.querySelector('svg');
  const label = btn.querySelector('.wishlist-btn-label');
  if (wishlisted) {
    btn.classList.add('is-wishlisted');
    if (svg) { svg.setAttribute('fill', '#e95144'); svg.setAttribute('stroke', '#e95144'); }
    if (label) label.textContent = 'Saved to Wishlist';
  } else {
    btn.classList.remove('is-wishlisted');
    if (svg) { svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); }
    if (label) label.textContent = 'Add to Wishlist';
  }
}

function updateWishlistCount() {
  const count = getWishlist().length;
  document.querySelectorAll('.wishlist-count').forEach(el => {
    el.textContent = count > 0 ? count : '';
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* Initialise all wishlist buttons on page */
function initWishlistButtons() {
  /* Collection grid buttons */
  document.querySelectorAll('.product-wishlist[data-product-id]').forEach(btn => {
    const id = btn.dataset.productId;
    updateWishlistBtnState(btn, isWishlisted(id));

    if (btn._wlInit) return;
    btn._wlInit = true;

    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const wishlisted = toggleWishlist(
        id,
        btn.dataset.title,
        btn.dataset.price,
        btn.dataset.image,
        btn.dataset.url
      );
      updateWishlistBtnState(btn, wishlisted);
      updateWishlistCount();
      showWishlistToast(wishlisted, btn.dataset.title);
    });
  });

  /* PDP button */
  document.querySelectorAll('.pdp-wishlist-btn[data-product-id]').forEach(btn => {
    const id = btn.dataset.productId;
    updateWishlistBtnState(btn, isWishlisted(id));

    if (btn._wlInit) return;
    btn._wlInit = true;

    btn.addEventListener('click', () => {
      const wishlisted = toggleWishlist(
        id,
        btn.dataset.title,
        btn.dataset.price,
        btn.dataset.image,
        btn.dataset.url
      );
      updateWishlistBtnState(btn, wishlisted);
      updateWishlistCount();
      showWishlistToast(wishlisted, btn.dataset.title);
    });
  });

  updateWishlistCount();
}

function showWishlistToast(added, title) {
  let toast = document.getElementById('wl-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'wl-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = added
    ? (title ? `"${title}" added to wishlist` : 'Added to wishlist')
    : 'Removed from wishlist';
  toast.classList.add('wl-toast--visible');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('wl-toast--visible'), 2800);
}

/* Render wishlist page grid */
function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  if (!grid) return;

  const items = getWishlist();

  if (items.length === 0) {
    grid.style.display = 'none';
    if (empty) empty.style.display = 'block';
    return;
  }

  grid.style.display = 'grid';
  if (empty) empty.style.display = 'none';

  grid.innerHTML = items.map(item => `
    <div class="wl-card" data-id="${item.id}">
      <a href="${item.url}" class="wl-card-img-wrap">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </a>
      <div class="wl-card-info">
        <a href="${item.url}" class="wl-card-title">${item.title}</a>
        <p class="wl-card-price">${item.price}</p>
        <div class="wl-card-actions">
          <a href="${item.url}" class="btn btn-primary wl-card-btn">View Item</a>
          <button class="wl-remove-btn" data-id="${item.id}" aria-label="Remove from wishlist">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');

  grid.querySelectorAll('.wl-remove-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      removeFromWishlist(btn.dataset.id);
      updateWishlistCount();
      renderWishlistPage();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  renderWishlistPage();
});
